var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 3c-.39782 0-.77936.15804-1.06066.43934C5.40804 3.72064 5.25 4.10218 5.25 4.5v15c0 .3978.15804.7794.43934 1.0607S6.35218 21 6.75 21h10.5c.3978 0 .7794-.158 1.0607-.4393s.4393-.6629.4393-1.0607v-9H13.5c-.5967 0-1.169-.2371-1.591-.65901-.4219-.42196-.659-.99425-.659-1.59099V3h-4.5Zm1.5 9.75c-.41421 0-.75.3358-.75.75s.33579.75.75.75h7.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75h-7.5Zm0 3.75c-.41421 0-.75.3358-.75.75s.33579.75.75.75h7.5c.4142 0 .75-.3358.75-.75s-.3358-.75-.75-.75h-7.5Z",
    fill: "#667E87"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 4.06066 17.6893 9H13.5c-.1989 0-.3897-.07902-.5303-.21967-.1407-.14065-.2197-.33142-.2197-.53033V4.06066Z",
    fill: "#667E87"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentFilled);
export default __webpack_public_path__ + "static/media/document_filled.ac696a9dcaec35a60e696d65c98ae2b9.svg";
export { ForwardRef as ReactComponent };